export enum ProgramTypeEnum {
    AllAbilities = 1,
    FemaleOnly = 2,
    Seniors = 3
}